import {Imports } from "../base/editor.interfaces";
import {fabric} from "fabric";


// tslint:disable:no-invalid-this
const globalImports: Imports = typeof global !== 'undefined' ? global as any : window as any;

globalImports.SF.Editor = globalImports.SF.Editor || {};
globalImports.SF.Editor.Image = fabric.util.createClass(globalImports.SF.Editor.Image, {
    className: 'image-customizer',
    reRenderCanvas: function ():void {
        if (this.group) {
            this.group.canvas.renderAll();
        }
    },
    setCrossOrigin: function(img: HTMLImageElement|HTMLCanvasElement): void {
        // If image is a data-url, Safari considers it as a changed image when cross origin is set.
        // Fabricjs later handles cross origin for non data-url images...
        if (img instanceof HTMLImageElement && img.src.indexOf('data') !== 0) {
            img.crossOrigin = 'anonymous';
        }
    },

});